import { createListenerMiddleware } from '@reduxjs/toolkit';
import { addMiddleware } from 'redux-dynamic-middlewares';
import { mapStateActions } from 'features/searchResultsMap';

const typeaheadInput = document.querySelector('[data-typeahead-input]');
const listenerMiddleware = createListenerMiddleware();

/**
 * Using the listener middleware to listen to the enableSearchWithinMap action.
 * This listener is in charge of cleaning the typeahead field when the enableSearchWithinMap action is dispatched.
 */
listenerMiddleware.startListening({
  type: mapStateActions.enableSearchWithinMap.type,
  effect: () => {
    typeaheadInput.value = '';
  },
});

addMiddleware(listenerMiddleware.middleware);
